import { Button, Input } from 'antd';
import React, { ReactElement } from 'react';
import { withRouter } from 'react-router-dom';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import { EditOutlined } from '@ant-design/icons';

const FormInputAndButtonGroup = (props: any): ReactElement => {
  const formConfig = useGetFormConfig(props);
  const { location: { pathname: url } } = props;
  let pageType = 'newAdmission';

  const {
    disabled,
    buttonDisabled,
    buttonLoading,
    onButtonClickHandler,
    buttonLabel,
    placeholder = '',
    onChange,
    showVerified,
    onEdit,
    key,
    onFocus,
    onBlur,
  } = formConfig;

  if (url?.indexOf('edit') >= 0) {
    pageType = 'edit';
  } else if (url?.indexOf('detail') >= 0) {
    pageType = 'detail';
  }

  return <>
    <FormItem
      formConfig={formConfig}
    >
      <Input
        placeholder={placeholder}
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        onBlur={(): void => onBlur && onBlur()}
        onFocus={(): void => onFocus && onFocus()}
      />
    </FormItem>
    <div>
      {showVerified && (
        <EditOutlined
          className="kyc-editbtn"
          onClick={onEdit(key)}
        />
      )}
    </div>
    {(pageType === 'edit' || pageType === 'newAdmission') && (
      <div>
        <Button
          onClick={onButtonClickHandler}
          loading={buttonLoading}
          disabled={buttonDisabled}
        >
          {buttonLabel}
        </Button>
      </div>
    )}
  </>;
};

export default withRouter(FormInputAndButtonGroup);
